import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { readStyle } from "./indicatorUtils";

const calculateTR = (current: KLineData, previous: KLineData): number => {
  const highLow = current.high - current.low;
  const highPrevClose = Math.abs(current.high - previous.close);
  const lowPrevClose = Math.abs(current.low - previous.close);
  return Math.max(highLow, highPrevClose, lowPrevClose);
};

export const createATR = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const atrS = readStyle(styles, "atr", "#2196F3");

  return {
    name: "atr",
    shortName: `ATR${period}`,
    calcParams: [period],
    series: "normal" as const,
    figures: [{ key: "atr", title: `ATR${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(atrS.color, 2, lineStyleToKLine(atrS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "atr", title: `ATR${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p] = (indicator.calcParams ?? [period]) as [number];
      const n = dataList.length;
      const results: Array<{ atr?: number }> = new Array(n);
      results[0] = {};

      let seedSum = 0;
      let atr = 0;
      let seeded = false;

      for (let i = 1; i < n; i++) {
        const tr = calculateTR(dataList[i]!, dataList[i - 1]!);
        if (!seeded) {
          seedSum += tr;
          if (i === p) {
            atr = seedSum / p;
            seeded = true;
            results[i] = { atr };
          } else {
            results[i] = {};
          }
        } else {
          atr = (atr * (p - 1) + tr) / p;
          results[i] = { atr };
        }
      }

      return results;
    },
  };
};
